import { z } from 'zod';

import { playerReportDataQuerySchema, playerReportUiStateSchema } from '../player-report';
import { sessionReportDataQuerySchema, sessionReportUiStateSchema } from '../session-report';
import { weeklyReportDataQuerySchema, weeklyReportUiStateSchema } from '../weekly-report';

export type CreateSharedPlayerReportData = z.output<typeof createSharedPlayerReportDataSchema>;
export type CreateSharedPlayerReportDataDTO = z.input<typeof createSharedPlayerReportDataSchema>;

export const createSharedPlayerReportDataSchema = z.object({
  params: playerReportDataQuerySchema,
  reference: z.string(),
  type: z.literal('player'),
  uiState: playerReportUiStateSchema,
});

export type CreateSharedSessionReportData = z.output<typeof createSharedSessionReportDataSchema>;
export type CreateSharedSessionReportDataDTO = z.input<typeof createSharedSessionReportDataSchema>;

export const createSharedSessionReportDataSchema = z.object({
  params: sessionReportDataQuerySchema,
  reference: z.string(),
  type: z.literal('session'),
  uiState: sessionReportUiStateSchema,
});

export type CreateSharedWeeklyReportData = z.output<typeof createSharedWeeklyReportDataSchema>;
export type CreateSharedWeeklyReportDataDTO = z.input<typeof createSharedWeeklyReportDataSchema>;

export const createSharedWeeklyReportDataSchema = z.object({
  params: weeklyReportDataQuerySchema,
  reference: z.string(),
  type: z.literal('weekly'),
  uiState: weeklyReportUiStateSchema,
});

export type CreateSharedReportData = z.output<typeof createSharedReportDataSchema>;
export type CreateSharedReportDataDTO = z.input<typeof createSharedReportDataSchema>;

export const createSharedReportDataSchema = z.discriminatedUnion('type', [
  createSharedPlayerReportDataSchema,
  createSharedSessionReportDataSchema,
  createSharedWeeklyReportDataSchema,
]);
